import PipAgendaWidget from "./PipAgendaWidget";
import PipCardsWidget from "./PipCardsWidget";

export default function PipOverlay({ items = [], coverage = {}, cards = [], meetingTitle, transcriptSpeaker, transcriptLine }) {
  return (
    <div
      className="h-screen flex flex-col gap-2.5 p-3 overflow-hidden"
      style={{ background: "hsl(40 14% 96%)" }}
    >
      {/* Title bar */}
      {meetingTitle && (
        <div className="flex items-center gap-2 px-1">
          <div className="w-1.5 h-1.5 rounded-full bg-emerald-500 animate-pulse shrink-0" />
          <span className="text-[11px] font-medium text-foreground/50 truncate">
            {meetingTitle}
          </span>
        </div>
      )}

      {/* Agenda widget */}
      <PipAgendaWidget items={items} coverage={coverage} />

      {/* Live transcript ticker */}
      {transcriptLine && (
        <div className="shrink-0 px-2 py-1.5 rounded-lg bg-foreground/[0.03] border border-border/40 flex items-baseline gap-1.5 min-w-0">
          {transcriptSpeaker && (
            <span className="text-[10px] font-semibold text-foreground/40 shrink-0">
              {transcriptSpeaker.split(" ")[0]}
            </span>
          )}
          <p className="text-[11px] text-muted-foreground/70 truncate leading-snug italic">
            &ldquo;{transcriptLine}&rdquo;
          </p>
        </div>
      )}

      {/* Cards widget -- takes remaining space */}
      <PipCardsWidget cards={cards} />
    </div>
  );
}
